import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const CardHeaderState = styled.div.withConfig({
  displayName: "TaskHeaderState__CardHeaderState",
  componentId: "sc-7fcmst-0"
})(["position:absolute;right:24px;top:24px;"]);
const TaskHeaderState = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CardHeaderState, {
    children: children
  });
};
export default TaskHeaderState;